import React, { /*useState,*/ /*useRef,*/ useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Box,
    Card,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import { selectUid/*, selectToken*/ } from '../login/LoginSlice';
import { getSummaryListAsync, selectCurrentPrj, selectSummaryList } from './SummarySlice';

//import { userSelectors }  from '../../state/ducks/user';
//import { summarySelectors, summaryOperations } from '../../state/ducks/summaries';

const Item = (props) => {
    const { sx, ...other } = props;
    return <Box sx={{ ...sx }} {...other} />;
};

const SummaryList = ({ ...props }) => {
    const dispatch = useDispatch();

    //const [items, setItems] = useState({ envs: [] });
    //const [prj, setPrj] = useState("");

    //const uid = useSelector(userSelectors.getUserId);
    //const token = useSelector(userSelectors.getToken);

    const uid = useSelector(selectUid);
    //const token = useSelector(selectToken);

    //const summaryList = useSelector(summarySelectors.getSummaryList);
    const summaryList = useSelector(selectSummaryList);

    const handleClick = (prj, page, e) => {
        //console.log(prj + ":" + page + " clicked.");
        //setPrj(prj);
        dispatch(selectCurrentPrj({prj:prj}))
    };

    const loadItems = () => {
        //summaryOperations.getList();
        dispatch(getSummaryListAsync({ /*token: token,*/ uid: uid }));
    };

    useEffect(() => {
        /*
        (async () => {
            loadItems();
        })();
        const interval = setInterval(() => {
            loadItems();
        }, 60000);
        return () => clearInterval(interval);
        */
        loadItems();

        const interval = setInterval(() => {
            loadItems();
        }, 60000);
        return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const envList = summaryList.envTypes.map((envType) => {
        
        if (summaryList.envPrjs[envType.envType].length === 0)
            return (<></>);
        
        return (
            <Accordion>
                <AccordionSummary
                    expandIcon={<i className="material-icons">expand_more</i>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>{envType.dispName}</Typography>
                </AccordionSummary>
                {summaryList.envPrjs[envType.envType].map((prjId) => {
                    let prj = summaryList.projects[prjId];
                    let psum = summaryList.summaries[prjId];
                    if (psum['status']==='NODATA') {
                        psum['alarm_ok_cnt'] = psum['alarm_ng_cnt'] = 
                        psum['check_site_ok_1h_cnt'] = psum['check_site_ng_1h_cnt'] = 
                        psum['check_job_ok_1h_cnt'] = psum['check_job_ng_1h_cnt'] = 
                        psum['check_maint_ok_1h_cnt'] = psum['check_maint_ng_1h_cnt'] = 
                        psum['check_site_ok_1d_cnt'] = psum['check_site_ng_1d_cnt'] = 
                        psum['check_job_ok_1d_cnt'] = psum['check_job_ng_1d_cnt'] = 
                        psum['check_maint_ok_1d_cnt'] = psum['check_maint_ng_1d_cnt'] = 
                        psum['error_1h_cnt'] = psum['error_1d_cnt'] = 'Miss';                    //psum['check_site_ok_cnt'] = psum['check_site_ng_cnt'] = 
                        //psum['check_job_ok_cnt'] = psum['check_job_ng_cnt'] = 
                        //psum['check_maint_ok_cnt'] = psum['check_maint_ng_cnt'] = 
                        //psum['error_new_cnt'] = psum['error_1d_cnt'] = 'Miss';
                    }
                
                    return listDetails(prj, psum);
                })}
            </Accordion>
        );
    });

    const listDetails = (prj, psum) => {
        return (
        <AccordionDetails>
            <Card sx={{ margin: 1, padding: 1 }}>
                <Box
                    sx={{
                        display: "grid",
                        columnGap: 0,
                        rowGap: 1,
                        gridTemplateColumns: "repeat(6,100px)"
                    }}
                >
                    <Item sx={{ gridColumn: "span 10" }}>
                        <h2 style={{ display: "inline" }}>
                            {prj.prjName} (ID:{prj.awsId})
                        </h2>
                    </Item>
                    <Item
                        sx={{ gridColumn: "span 2" }}
                        onClick={(e) => handleClick(prj, "ALARM", e)}
                    >
                        <h3 style={{ display: "inline" }}>Alarm</h3>
                    </Item>
                    <Item
                        sx={{ gridColumn: "span 1" }}
                    >
                    </Item>
                    <Item
                        sx={{ gridColumn: "span 2" }}
                        onClick={(e) => handleClick(prj, "CHECK", e)}
                    >
                        <h3 style={{ display: "inline" }}>Site Check</h3>
                    </Item>
                    <Item
                        sx={{ gridColumn: "span 2" }}
                        onClick={(e) => handleClick(prj, "CHECK", e)}
                    >
                        <h3 style={{ display: "inline" }}>Batch Job</h3>
                    </Item>
                    <Item
                        sx={{ gridColumn: "span 2" }}
                        onClick={(e) => handleClick(prj, "CHECK", e)}
                    >
                        <h3 style={{ display: "inline" }}>Maintenance</h3>
                    </Item>
                    
                    <Item
                        
                        onClick={(e) => handleClick(prj, "ERROR", e)}
                    >
                        <h3 style={{ display: "inline" }}>ERROR LOG</h3>
                    </Item>

                    <Item sx={{ gridRow: "span 2" }}
                        onClick={(e) => handleClick(prj, "ALARM", e)}>
                        <i className="material-icons">check_circle</i> {psum.alarm_ok_cnt}
                    </Item>
                    <Item  sx={{ gridRow: "span 2" }}
                        onClick={(e) => handleClick(prj, "ALARM", e)}>
                        <i className="material-icons">error</i> {psum.alarm_ng_cnt}
                    </Item>

                    <Item>1H</Item>

                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">check_circle</i>  {psum.check_site_ok_1h_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">error</i>  {psum.check_site_ng_1h_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">check_circle</i>  {psum.check_job_ok_1h_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">error</i>  {psum.check_job_ng_1h_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">check_circle</i>  {psum.check_maint_ok_1h_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">error</i>  {psum.check_maint_ng_1h_cnt}
                    </Item>

                    <Item onClick={(e) => handleClick(prj, "ERROR", e)}>
                        <i className="material-icons">new_releases</i>  {psum.error_1h_cnt}
                    </Item>

                    <Item>1D</Item>

                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">check_circle</i>  {psum.check_site_ok_1d_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">error</i>  {psum.check_site_ng_1d_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">check_circle</i>  {psum.check_job_ok_1d_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">error</i>  {psum.check_job_ng_1d_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">check_circle</i>  {psum.check_maint_ok_1d_cnt}
                    </Item>
                    <Item onClick={(e) => handleClick(prj, "CHECK", e)}>
                        <i className="material-icons">error</i>  {psum.check_maint_ng_1d_cnt}
                    </Item>

                    <Item onClick={(e) => handleClick(prj, "ERROR", e)}>
                        <i className="material-icons">view_headline</i>  {psum.error_1d_cnt} (24H)
                    </Item>
                </Box>
            </Card>
        </AccordionDetails>
        );

    };

    return (
        <div>
            {envList}
        </div>
    );
};

export default SummaryList;
